/*
 *
 * FulfillmentNoteDetailPage actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';

import ActionTypes from './constants';
import { FulfillmentNote, MutationSubmitFeedbackArgs } from 'types/schema';

export const defaultAction = () => action(ActionTypes.DEFAULT_ACTION);
export const fulfillmentNote = createAsyncAction(
  ActionTypes.FETCH_FULFILLMENT_NOTE_REQUEST,
  ActionTypes.FETCH_FULFILLMENT_NOTE_SUCCESS,
  ActionTypes.FETCH_FULFILLMENT_NOTE_FAILURE,
)<void, {}, Error>();

export const bulkReOrderSubmit = (data: any) => action(ActionTypes.BULK_REORDER, data);

export const bulkReorder = createAsyncAction(
  ActionTypes.BULK_REORDER_REQUEST,
  ActionTypes.BULK_REORDER_SUCCESS,
  ActionTypes.BULK_REORDER_FAILURE,
)<void, {}, Error>();

export const ratingAction = createAsyncAction(
  ActionTypes.RATE_REQUEST,
  ActionTypes.RATE_SUCCESS,
  ActionTypes.RATE_FAILURE,
)<void, {}, Error>();

export const openModal = (data: FulfillmentNote) => action(ActionTypes.RATING_MODAL_OPEN, data);
export const closeModal = () => action(ActionTypes.RATING_MODAL_CLOSE);
export const submitFeedback = (data: MutationSubmitFeedbackArgs['input']) => action(ActionTypes.RATE, data);

export const downloadDeliveryNote = (fulfillmentNoteId: string, cb: () => void) =>
  action(ActionTypes.DOWNLOAD_DELIVERY_NOTE, { fulfillmentNoteId: fulfillmentNoteId, cb: cb });
